import { defineMessages } from 'react-intl-next';

const msgForCommented = defineMessages({
	otherIndividualCommentedToday: {
		id: 'ptc-directory.team-profile-page.team-work.individual.other.commented.today',
		defaultMessage: '{name} commented here today',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when somebody else commented on the work today.',
	},
	otherIndividualCommentedYesterday: {
		id: 'ptc-directory.team-profile-page.team-work.individual.other.commented.yesterday',
		defaultMessage: '{name} commented here yesterday',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when somebody else commented on the work yesterday.',
	},
	otherIndividualCommentedTime: {
		id: 'ptc-directory.team-profile-page.team-work.individual.other.commented.time',
		defaultMessage: '{name} commented here on {time}',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when somebody else commented on the work earlier than yesterday.',
	},
});

const msgForCreated = defineMessages({
	otherIndividualCreatedToday: {
		id: 'ptc-directory.team-profile-page.team-work.individual.other.created.today',
		defaultMessage: '{name} created this today',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when somebody else created the work today.',
	},
	otherIndividualCreatedYesterday: {
		id: 'ptc-directory.team-profile-page.team-work.individual.other.created.yesterday',
		defaultMessage: '{name} created this yesterday',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when somebody else created the work yesterday',
	},
	otherIndividualCreatedTime: {
		id: 'ptc-directory.team-profile-page.team-work.individual.other.created.time',
		defaultMessage: '{name} created this on {time}',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when somebody else created the work earlier than yesterday.',
	},
});

const msgForEdited = defineMessages({
	otherIndividualEditedToday: {
		id: 'ptc-directory.team-profile-page.team-work.individual.other.edited.today',
		defaultMessage: '{name} edited this today',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when somebody else edited the work today',
	},
	otherIndividualEditedYesterday: {
		id: 'ptc-directory.team-profile-page.team-work.individual.other.edited.yesterday',
		defaultMessage: '{name} edited this yesterday',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when somebody else edited the work yesterday',
	},
	otherIndividualEditedTime: {
		id: 'ptc-directory.team-profile-page.team-work.individual.other.edited.time',
		defaultMessage: '{name} edited this on {time}',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when somebody else edited the work earlier than yesterday',
	},
});

const msgForWorked = defineMessages({
	otherIndividualWorkedToday: {
		id: 'ptc-directory.team-profile-page.team-work.individual.other.worked.today',
		defaultMessage: '{name} worked on this today',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when somebody else performed an unknown operation on the work today',
	},
	otherIndividualWorkedYesterday: {
		id: 'ptc-directory.team-profile-page.team-work.individual.other.worked.yesterday',
		defaultMessage: '{name} worked on this yesterday',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when somebody else performed an unknown operation on the work yesterday',
	},
	otherIndividualWorkedTime: {
		id: 'ptc-directory.team-profile-page.team-work.individual.other.worked.time',
		defaultMessage: '{name} worked on this on {time}',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when somebody else performed an unknown operation on the work earlier than yesterday',
	},
});

const msgForAssigned = defineMessages({
	otherIndividualAssignedToday: {
		id: 'ptc-directory.team-profile-page.team-work.individual.other.assigned.today',
		defaultMessage: '{name} was assigned this today',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when somebody else assigned the work today',
	},
	otherIndividualAssignedYesterday: {
		id: 'ptc-directory.team-profile-page.team-work.individual.other.assigned.yesterday',
		defaultMessage: '{name} was assigned this yesterday',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when somebody else assigned the work yesterday',
	},
	otherIndividualAssignedTime: {
		id: 'ptc-directory.team-profile-page.team-work.individual.other.assigned.time',
		defaultMessage: '{name} was assigned this on {time}',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when somebody else assigned the work earlier than yesterday',
	},
});

const msgForUnassigned = defineMessages({
	otherIndividualUnassignedToday: {
		id: 'ptc-directory.team-profile-page.team-work.individual.other.unassigned.today',
		defaultMessage: '{name} was unassigned this today',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when somebody else unassigned the work today',
	},
	otherIndividualUnassignedYesterday: {
		id: 'ptc-directory.team-profile-page.team-work.individual.other.unassigned.yesterday',
		defaultMessage: '{name} was unassigned this yesterday',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when somebody else unassigned the work yesterday',
	},
	otherIndividualUnassignedTime: {
		id: 'ptc-directory.team-profile-page.team-work.individual.other.unassigned.time',
		defaultMessage: '{name} was unassigned this on {time}',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when somebody else unassigned the work earlier than yesterday',
	},
});

const msgForLiked = defineMessages({
	otherIndividualLikedToday: {
		id: 'ptc-directory.team-profile-page.team-work.individual.other.liked.today',
		defaultMessage: '{name} liked this today',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when somebody else liked the work today',
	},
	otherIndividualLikedYesterday: {
		id: 'ptc-directory.team-profile-page.team-work.individual.other.liked.yesterday',
		defaultMessage: '{name} liked this yesterday',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when somebody else liked the work yesterday',
	},
	otherIndividualLikedTime: {
		id: 'ptc-directory.team-profile-page.team-work.individual.other.liked.time',
		defaultMessage: '{name} liked this on {time}',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when somebody else liked the work earlier than yesterday',
	},
});

const msgForPublished = defineMessages({
	otherIndividualPublishedToday: {
		id: 'ptc-directory.team-profile-page.team-work.individual.other.published.today',
		defaultMessage: '{name} published this today',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when somebody else published the work today',
	},
	otherIndividualPublishedYesterday: {
		id: 'ptc-directory.team-profile-page.team-work.individual.other.published.yesterday',
		defaultMessage: '{name} published this yesterday',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when somebody else published the work yesterday',
	},
	otherIndividualPublishedTime: {
		id: 'ptc-directory.team-profile-page.team-work.individual.other.published.time',
		defaultMessage: '{name} published this on {time}',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when somebody else published the work earlier than yesterday',
	},
});

const msgForUpdated = defineMessages({
	otherIndividualUpdatedToday: {
		id: 'ptc-directory.team-profile-page.team-work.individual.other.updated.today',
		defaultMessage: '{name} updated this today',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when somebody else updated the work today',
	},
	otherIndividualUpdatedYesterday: {
		id: 'ptc-directory.team-profile-page.team-work.individual.other.updated.yesterday',
		defaultMessage: '{name} updated this yesterday',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when somebody else updated the work yesterday',
	},
	otherIndividualUpdatedTime: {
		id: 'ptc-directory.team-profile-page.team-work.individual.other.updated.time',
		defaultMessage: '{name} updated this on {time}',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when somebody else updated the work earlier than yesterday',
	},
});

// Messages for when someone that isn't you performed an action
export const messages = {
	...msgForCommented,
	...msgForCreated,
	...msgForEdited,
	...msgForWorked,
	...msgForAssigned,
	...msgForUnassigned,
	...msgForLiked,
	...msgForPublished,
	...msgForUpdated,
};
